/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

import type { Body_add_your_food_api_v1_meals_your_food_post } from "../models/Body_add_your_food_api_v1_meals_your_food_post";
import type { DataMessageResponse_CarbSwapsResponse_ } from "../models/DataMessageResponse_CarbSwapsResponse_";
import type { DataMessageResponse_DislikedMealsResponse_ } from "../models/DataMessageResponse_DislikedMealsResponse_";
import type { DataMessageResponse_EditMealResult_ } from "../models/DataMessageResponse_EditMealResult_";
import type { DataMessageResponse_FavouriteMealsResponse_ } from "../models/DataMessageResponse_FavouriteMealsResponse_";
import type { DataMessageResponse_FruitPicksResponse_ } from "../models/DataMessageResponse_FruitPicksResponse_";
import type { DataMessageResponse_HomeFeedResponse_ } from "../models/DataMessageResponse_HomeFeedResponse_";
import type { DataMessageResponse_FoodLibraryResponse_ } from "../models/DataMessageResponse_FoodLibraryResponse_";
import type { DataMessageResponse_Meal_ } from "../models/DataMessageResponse_Meal_";
import type { DataMessageResponse_MealSearchFiltersInfo_ } from "../models/DataMessageResponse_MealSearchFiltersInfo_";
import type { DataMessageResponse_MealSearchResponse_ } from "../models/DataMessageResponse_MealSearchResponse_";
import type { DataMessageResponse_MilkOptionsResponse_ } from "../models/DataMessageResponse_MilkOptionsResponse_";
import type { DataMessageResponse_ScaledServingsResponse_ } from "../models/DataMessageResponse_ScaledServingsResponse_";
import type { DataMessageResponse_TaskResultResponse_ } from "../models/DataMessageResponse_TaskResultResponse_";
import type { DataMessageResponse_TaskStatusResponse_ } from "../models/DataMessageResponse_TaskStatusResponse_";
import type { DataMessageResponse_TopPicksResponse_ } from "../models/DataMessageResponse_TopPicksResponse_";
import type { DataMessageResponse_YourFoodMealsResponse_ } from "../models/DataMessageResponse_YourFoodMealsResponse_";
import type { DislikedMealRequest } from "../models/DislikedMealRequest";
import type { EditYourFoodRequest } from "../models/EditYourFoodRequest";
import type { EditMealRequest } from "../models/EditMealRequest";
import type { FavouriteMealRequest } from "../models/FavouriteMealRequest";
import type { MealSearchRequest } from "../models/MealSearchRequest";
import type { MealTime } from "../models/MealTime";
import type { MessageOnlyResponse } from "../models/MessageOnlyResponse";
import type { RemoveDislikedMealRequest } from "../models/RemoveDislikedMealRequest";
import type { RemoveFavouriteMealRequest } from "../models/RemoveFavouriteMealRequest";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class MealsService {
  /**
   * Edit Meal
   * Manually edit nutrition, forking shared catalog meals into private Your Food meals.
   * Existing plan snapshots are left unchanged.
   */
  public static editMealApiV1MealsMealIdPatch(
    mealId: string,
    requestBody: EditMealRequest,
  ): CancelablePromise<DataMessageResponse_EditMealResult_> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v1/meals/{meal_id}",
      path: {
        meal_id: mealId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Search Meals
   * Perform semantic search for meals based on query and optional filters.
   *
   * ## Request Body:
   * - **query**: Search query string for semantic similarity matching (optional - if omitted, returns meals filtered by metadata only)
   * - **meal_time**: Optional meal time filter (breakfast, lunch, dinner, snack)
   * - **meal_type_category**: Optional single meal type category filter
   * - **include_meal_type_categories**: Optional list of meal type categories to include
   * - **exclude_meal_type_categories**: Optional list of meal type categories to exclude
   * - **dietary_preferences**: Optional list of dietary restrictions
   * - **supermarket_preferences**: Optional list of supermarket preferences
   * - **calorie_min**: Optional minimum calories
   * - **calorie_max**: Optional maximum calories
   * - **brand_filter**: Optional brand filter
   * - **limit**: Maximum number of results to return (default 10, max 50)
   *
   * ## Example Request Body:
   * ```json
   * {
   * "query": "chicken salad",
   * "meal_time": "lunch",
   * "exclude_meal_type_categories": ["coffeeShop", "quickBites"],
   * "dietary_preferences": ["glutenFree"],
   * "limit": 10
   * }
   * ```
   * @param xUserId
   * @param requestBody
   * @returns DataMessageResponse_MealSearchResponse_ Successful Response
   * @throws ApiError
   */
  public static searchMealsApiV1MealsSearchPost(
    xUserId: string,
    requestBody: MealSearchRequest,
  ): CancelablePromise<DataMessageResponse_MealSearchResponse_> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/meals/search",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Search Filters
   * Get information about available search filters for meal semantic search.
   *
   * Returns all available meal time and meal type category filter options
   * with descriptions for use in search functionality.
   * @returns DataMessageResponse_MealSearchFiltersInfo_ Successful Response
   * @throws ApiError
   */
  public static getSearchFiltersApiV1MealsSearchFiltersGet(): CancelablePromise<DataMessageResponse_MealSearchFiltersInfo_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/meals/search/filters",
    });
  }
  /**
   * Get Carb Swaps
   * Get all available carb swap options with structured metadata.
   *
   * Returns all carb swaps with:
   * - Name
   * - Uncooked weight (grams)
   * - Cooked weight (grams)
   * - S3 image URL
   * - Type (branded or standardised)
   *
   * ## Response Structure
   * Each carb swap includes:
   * - **name**: Display name (e.g., "McCain Naked Oven Chips")
   * - **weightUncookedGrams**: Weight in grams when uncooked
   * - **weightCookedGrams**: Weight in grams when cooked
   * - **imageUrl**: Public S3 URL for the carb image
   * - **type**: Either "branded" or "standardised"
   *
   * ## Example
   * ```json
   * {
   * "data": {
   * "carbSwaps": [
   * {
   * "name": "McCain Naked Oven Chips",
   * "weightUncookedGrams": 145,
   * "weightCookedGrams": 145,
   * "imageUrl": "https://nutricoach-meal-images-eu-west-2.s3.eu-west-2.amazonaws.com/carb-swaps/branded/McCain%20Oven%20Chips.png",
   * "type": "branded"
   * }
   * ]
   * }
   * }
   * ```
   * @returns DataMessageResponse_CarbSwapsResponse_ Successful Response
   * @throws ApiError
   */
  public static getCarbSwapsApiV1MealsCarbSwapsGet(): CancelablePromise<DataMessageResponse_CarbSwapsResponse_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/meals/carb-swaps",
    });
  }
  /**
   * Get Fruit Picks
   * Get all available fruit pick options.
   *
   * Returns all fruits with:
   * - Name
   * - Quantity description
   * - S3 image URL
   *
   * ## Response Structure
   * Each fruit pick includes:
   * - **name**: Display name (e.g., "Apple")
   * - **quantity**: Quantity description (e.g., "1x Large or 2x Small")
   * - **imageUrl**: Public S3 URL for the fruit image
   *
   * ## Example
   * ```json
   * {
   * "data": {
   * "fruitPicks": [
   * {
   * "name": "Apple",
   * "quantity": "1x Large or 2x Small",
   * "imageUrl": "https://nutricoach-meal-images-eu-west-2.s3.eu-west-2.amazonaws.com/fruit-picks/apple.png"
   * }
   * ]
   * }
   * }
   * ```
   * @returns DataMessageResponse_FruitPicksResponse_ Successful Response
   * @throws ApiError
   */
  public static getFruitPicksApiV1MealsFruitPicksGet(): CancelablePromise<DataMessageResponse_FruitPicksResponse_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/meals/fruit-picks",
    });
  }
  /**
   * Get Milk Options
   * Get available milk options filtered by user's dietary requirements.
   *
   * Returns personalized milk options based on:
   * - Dairy-free requirement
   *
   * The business logic for filtering is handled by MilkOptionsService in domain layer.
   * @param xUserId
   * @returns DataMessageResponse_MilkOptionsResponse_ Successful Response
   * @throws ApiError
   */
  public static getMilkOptionsApiV1MealsMilkOptionsGet(
    xUserId: string,
  ): CancelablePromise<DataMessageResponse_MilkOptionsResponse_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/meals/milk-options",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Popular Meals
   * Get popular meals filtered by user's dietary requirements, dislikes, and allergens.
   *
   * Returns up to 15 randomly selected popular meals from the homepage feeds,
   * personalised by excluding meals that conflict with the user's preferences.
   * @param xUserId
   * @returns DataMessageResponse_HomeFeedResponse_ Successful Response
   * @throws ApiError
   */
  public static getPopularMealsApiV1MealsPopularGet(
    xUserId: string,
  ): CancelablePromise<DataMessageResponse_HomeFeedResponse_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/meals/popular",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get High Protein Meals
   * Get high-protein meals filtered by user's dietary requirements, dislikes, and allergens.
   *
   * Returns up to 15 randomly selected high-protein meals from the homepage feeds,
   * personalised by excluding meals that conflict with the user's preferences.
   * @param xUserId
   * @returns DataMessageResponse_HomeFeedResponse_ Successful Response
   * @throws ApiError
   */
  public static getHighProteinMealsApiV1MealsHighProteinGet(
    xUserId: string,
  ): CancelablePromise<DataMessageResponse_HomeFeedResponse_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/meals/high-protein",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Top Picks
   * Your Top Picks — three suggested meals for the next eating slot.
   *
   * Returns three tagged cards:
   * - your_usual: the meal eaten most often in this slot (last 8 weeks).
   * - quick_pick: a fresh quick recipe seeded by the user's like-signals
   * (snack slot also allows supermarket grab-and-go).
   * - often_picked: the user's next most-eaten meal in this slot.
   *
   * Each card carries calories + macros. Cards that can't be filled from their
   * primary source fall back to the popular + high-protein feeds while keeping
   * their tag.
   * @param mealTime Meal slot to suggest for. Defaults to the current meal window, then breakfast.
   * @returns DataMessageResponse_TopPicksResponse_ Successful Response
   * @throws ApiError
   */
  public static getTopPicksApiV1MealsTopPicksGet(
    mealTime?: MealTime | null,
  ): CancelablePromise<DataMessageResponse_TopPicksResponse_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/meals/top-picks",
      query: {
        meal_time: mealTime,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Add Favourite Meal
   * Add a meal to user's favourites for a specific meal time.
   *
   * Uses hybrid event sourcing:
   * - Writes favouriteMeal event to UserMealInteractions
   * - Updates MealSuggestions state table (simple list for fast serving)
   * @param xUserId
   * @param requestBody
   * @returns MessageOnlyResponse Successful Response
   * @throws ApiError
   */
  public static addFavouriteMealApiV1MealsFavouritesPost(
    xUserId: string,
    requestBody: FavouriteMealRequest,
  ): CancelablePromise<MessageOnlyResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/meals/favourites",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Favourite Meals
   * Get all favourite meals for a user across all meal times.
   *
   * Returns full Meal objects for all favourited meals.
   * @param xUserId
   * @returns DataMessageResponse_FavouriteMealsResponse_ Successful Response
   * @throws ApiError
   */
  public static getFavouriteMealsApiV1MealsFavouritesGet(
    xUserId: string,
  ): CancelablePromise<DataMessageResponse_FavouriteMealsResponse_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/meals/favourites",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Remove Favourite Meal
   * Remove a meal from user's favourites for a specific meal time (undo operation).
   *
   * If the meal is not in favourites, returns a message indicating so.
   * @param xUserId
   * @param requestBody
   * @returns MessageOnlyResponse Successful Response
   * @throws ApiError
   */
  public static removeFavouriteMealApiV1MealsFavouritesDelete(
    xUserId: string,
    requestBody: RemoveFavouriteMealRequest,
  ): CancelablePromise<MessageOnlyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v1/meals/favourites",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get My Foods
   * Return the user's complete food library for client-side search and ordering.
   * @returns DataMessageResponse_FoodLibraryResponse_ Successful Response
   * @throws ApiError
   */
  public static getMyFoodsApiV1MealsMyFoodsGet(): CancelablePromise<DataMessageResponse_FoodLibraryResponse_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/meals/my-foods",
    });
  }
  /**
   * Remove My Food
   * Hide a food-library item while preserving its source records and history.
   * @param mealId
   * @returns MessageOnlyResponse Successful Response
   * @throws ApiError
   */
  public static removeMyFoodApiV1MealsMyFoodsMealIdDelete(
    mealId: string,
  ): CancelablePromise<MessageOnlyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v1/meals/my-foods/{meal_id}",
      path: {
        meal_id: mealId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Add Disliked Meal
   * Add a meal to user's disliked list (global across all meal times).
   *
   * Uses hybrid event sourcing:
   * - Writes dislikedMeal event to UserMealInteractions
   * - Updates MealSuggestions state table (simple list for fast serving)
   *
   * Disliked meals will be filtered out from meal alternatives.
   * @param xUserId
   * @param requestBody
   * @returns MessageOnlyResponse Successful Response
   * @throws ApiError
   */
  public static addDislikedMealApiV1MealsDislikedPost(
    xUserId: string,
    requestBody: DislikedMealRequest,
  ): CancelablePromise<MessageOnlyResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/meals/disliked",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Disliked Meals
   * Get all disliked meals for a user.
   *
   * Returns full Meal objects for all disliked meals.
   * Disliked meals are global across all meal times.
   * @param xUserId
   * @returns DataMessageResponse_DislikedMealsResponse_ Successful Response
   * @throws ApiError
   */
  public static getDislikedMealsApiV1MealsDislikedGet(
    xUserId: string,
  ): CancelablePromise<DataMessageResponse_DislikedMealsResponse_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/meals/disliked",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Remove Disliked Meal
   * Remove a meal from user's disliked list (undo operation).
   *
   * If the meal is not in disliked list, returns a message indicating so.
   * @param xUserId
   * @param requestBody
   * @returns MessageOnlyResponse Successful Response
   * @throws ApiError
   */
  public static removeDislikedMealApiV1MealsDislikedDelete(
    xUserId: string,
    requestBody: RemoveDislikedMealRequest,
  ): CancelablePromise<MessageOnlyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v1/meals/disliked",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Add Your Food
   * Add a meal into NutriCoach user's profile from URL, image URL, uploaded image, or free text.
   *
   * This endpoint accepts one of four input types:
   * 1. **url**: Social media URL (TikTok, Instagram) or recipe website URL
   * 2. **image_url**: Remote image URL containing recipe or ingredient information
   * 3. **image**: Uploaded image file (JPEG, PNG, HEIC - max 25MB) - picture of a written recipe
   * 4. **free_text**: Free-form text containing ingredients and instructions (with optional recipe_name)
   *
   * An optional **food_image** can be provided alongside any of the above inputs:
   * - **food_image**: Uploaded food image file (JPEG, PNG, HEIC - max 25MB) - picture of the actual food
   *
   * The extraction is processed asynchronously in the background. Use the returned meal_id
   * to check status and retrieve results via the GET /your-food/{meal_id}/status endpoint.
   *
   * ## Parameters:
   * - **url**: (Optional) Social media or recipe URL
   * - **image_url**: (Optional) Remote image URL
   * - **image**: (Optional) Image file upload (picture of written recipe)
   * - **food_image**: (Optional) Food image file upload (picture of the actual food)
   * - **free_text**: (Optional) Free-form text with ingredients and instructions
   * - **recipe_name**: (Optional) User-provided recipe name (used with free_text)
   * - **meal_time**: (Required) When this meal will be consumed (breakfast, lunch, dinner, snack)
   *
   * **Note**: At least one of url/image_url/image/free_text must be provided. food_image is optional and can be provided alongside any other input. meal_time is always required.
   *
   * ## Returns:
   * - **meal_id**: Unique identifier for tracking the added meal
   * - **status**: Initial status (always "processing")
   * - **message**: Informative message about submission
   *
   * ## Examples:
   * - URL extraction: `curl -F "url=https://www.instagram.com/p/..." -F "meal_time=breakfast" -H "x-api-key: ..." -H "Authorization: Bearer ..." http://localhost:5000/api/v1/meals/your-food`
   * - Image URL: `curl -F "image_url=https://example.com/recipe.jpg" -F "meal_time=lunch" -H "x-api-key: ..." -H "Authorization: Bearer ..." http://localhost:5000/api/v1/meals/your-food`
   * - File upload: `curl -F "image=@recipe.jpg" -F "meal_time=dinner" -H "x-api-key: ..." -H "Authorization: Bearer ..." http://localhost:5000/api/v1/meals/your-food`
   * - Free text: `curl -F "free_text=Ingredients: 200g chicken, 1 cup rice. Instructions: Cook rice, grill chicken." -F "recipe_name=My Chicken Rice Bowl" -F "meal_time=lunch" -H "x-api-key: ..." -H "Authorization: Bearer ..." http://localhost:5000/api/v1/meals/your-food`
   * - With food image: `curl -F "image=@recipe.jpg" -F "food_image=@food.jpg" -F "meal_time=dinner" -H "x-api-key: ..." -H "Authorization: Bearer ..." http://localhost:5000/api/v1/meals/your-food`
   * @param xUserId
   * @param formData
   * @returns DataMessageResponse_TaskStatusResponse_ Successful Response
   * @throws ApiError
   */
  public static addYourFoodApiV1MealsYourFoodPost(
    xUserId: string,
    formData: Body_add_your_food_api_v1_meals_your_food_post,
  ): CancelablePromise<DataMessageResponse_TaskStatusResponse_> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/meals/your-food",
      headers: {
        "x-user-id": xUserId,
      },
      formData: formData,
      mediaType: "multipart/form-data",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Your Food
   * Get all Your Food meals for a user grouped by meal time.
   * @param xUserId
   * @returns DataMessageResponse_YourFoodMealsResponse_ Successful Response
   * @throws ApiError
   */
  public static getYourFoodApiV1MealsYourFoodGet(
    xUserId: string,
  ): CancelablePromise<DataMessageResponse_YourFoodMealsResponse_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/meals/your-food",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Your Food Status
   * Check the processing status and retrieve results of an added meal.
   *
   * Use this endpoint to check the status and retrieve results of a meal
   * submitted via the POST /your-food endpoint.
   *
   * ## Parameters:
   * - **meal_id**: The meal ID returned from the POST /your-food endpoint
   *
   * ## Returns:
   * - **meal_id**: The meal identifier
   * - **status**: Current status of the meal ("processing", "completed", or "failed")
   * - **error_message**: Error message if extraction failed, null otherwise
   *
   * ## Status Values:
   * - **processing**: Meal is still being processed, check back later
   * - **completed**: Meal completed successfully, result is available
   * - **failed**: Meal failed
   *
   * ## Example:
   * ```bash
   * curl -H "x-api-key: ..." -H "Authorization: Bearer ..."          http://localhost:5000/api/v1/meals/your-food/abc-123-def-456/status
   * ```
   * @param mealId
   * @param xUserId
   * @returns DataMessageResponse_TaskResultResponse_ Successful Response
   * @throws ApiError
   */
  public static getYourFoodStatusApiV1MealsYourFoodMealIdStatusGet(
    mealId: string,
    xUserId: string,
  ): CancelablePromise<DataMessageResponse_TaskResultResponse_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/meals/your-food/{meal_id}/status",
      path: {
        meal_id: mealId,
      },
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Edit Your Food
   * Edit an existing Your Food meal.
   *
   * Updates ingredients, portion size, instructions, and/or recipe name.
   * Recalculates nutrition based on changes using diff-based processing.
   * This endpoint is async to prevent blocking while AI processes ingredient changes.
   *
   * ## Path Parameters:
   * - **meal_id**: The ID of the meal to edit (must be a YF* meal)
   *
   * ## Request Body:
   * - **meal_time**: When this meal is consumed (breakfast, lunch, dinner, snack)
   * - **portion_size**: Number of servings (1, 2, 4, etc.)
   * - **recipe_name**: Name of the recipe
   * - **ingredients**: List of ingredients as strings (e.g., "200g chicken breast", "1 cup rice")
   * - **instructions**: List of cooking instruction strings
   *
   * ## Returns:
   * - The updated meal object with recalculated nutrition
   *
   * ## Example:
   * ```bash
   * curl -X PUT "http://localhost:5000/api/v1/meals/your-food/YF123-abc"       -H "Content-Type: application/json"       -H "x-api-key: your-api-key"       -H "Authorization: Bearer your-token"       -d '{
   * "meal_time": "lunch",
   * "portion_size": 4,
   * "recipe_name": "Grilled Chicken Salad",
   * "ingredients": [
   * "200g chicken breast",
   * "100g mixed salad greens",
   * "1 tbsp olive oil"
   * ],
   * "instructions": ["Grill the chicken", "Toss the salad"]
   * }'
   * @param mealId
   * @param xUserId
   * @param requestBody
   * @returns DataMessageResponse_Meal_ Successful Response
   * @throws ApiError
   */
  public static editYourFoodApiV1MealsYourFoodMealIdPut(
    mealId: string,
    xUserId: string,
    requestBody: EditYourFoodRequest,
  ): CancelablePromise<DataMessageResponse_Meal_> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/meals/your-food/{meal_id}",
      path: {
        meal_id: mealId,
      },
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Scaled Servings
   * Get ingredient quantities scaled to a desired number of servings.
   *
   * ## Parameters:
   * - **meal_id**: The ID of the meal to scale
   * - **serving_size**: The desired number of servings (positive integer, must be > 0)
   * - **day**: Optional day of week when this meal is consumed. If not provided, searches entire plan.
   * - **meal_time**: Optional meal time when this meal is consumed. If not provided, searches entire plan.
   * - **meal_index**: Optional index for meals with multiple items (default: 0, primarily for snacks)
   * - **source**: Data source. 'latest' (default) fetches fresh ingredient data from DynamoDB; 'plan' reads from the plan snapshot (use from the weekly plan screen only).
   *
   * ## Returns:
   * - **mealId**: The meal ID
   * - **scaledIngredientQuantities**: List of ingredient quantities scaled to the desired servings
   *
   * ## Example:
   * If a recipe has single-portion ingredients ["100g pasta", "50g sauce"]
   * and you request 3 servings, you'll get ["300g pasta", "150g sauce"].
   *
   * ## Notes:
   * - Uses the standardized `ingredients` field from the meal (which contains single-portion ingredients for recipes)
   * - Handles Q2 (double portion) meals by doubling ingredients before scaling
   * - Non-scalable items (pinch, drizzle, to taste) remain unchanged
   * - Applies rounding rules for practical measurements
   * @param mealId
   * @param servingSize The number of servings to scale to (must be positive)
   * @param xUserId
   * @param day Day of week (monday, tuesday, wednesday, thursday, friday, saturday, sunday). If not provided, searches entire plan for first occurrence.
   * @param mealTime Meal time (breakfast, lunch, dinner, snack). If not provided, searches entire plan for first occurrence.
   * @param mealIndex Index of meal in meal time group (for snacks with multiple items)
   * @param source Data source: 'latest' (default) fetches fresh data from DynamoDB; 'plan' uses the plan snapshot (for the weekly plan screen).
   * @param targetDate ISO date (YYYY-MM-DD) of the day being inspected. Only used when source='plan' — determines which week's snapshot is read so previous-week Q2 meals scale correctly. Defaults to current week if omitted.
   * @returns DataMessageResponse_ScaledServingsResponse_ Successful Response
   * @throws ApiError
   */
  public static getScaledServingsApiV1MealsMealIdServingsServingSizeGet(
    mealId: string,
    servingSize: number,
    xUserId: string,
    day?: string | null,
    mealTime?: string | null,
    mealIndex?: number,
    source: string = "latest",
    targetDate?: string | null,
  ): CancelablePromise<DataMessageResponse_ScaledServingsResponse_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/meals/{meal_id}/servings/{serving_size}",
      path: {
        meal_id: mealId,
        serving_size: servingSize,
      },
      headers: {
        "x-user-id": xUserId,
      },
      query: {
        day: day,
        meal_time: mealTime,
        meal_index: mealIndex,
        source: source,
        target_date: targetDate,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
